module.exports = {"640122100":"习岗镇","640122101":"金贵镇","640122102":"立岗镇","640122103":"洪广镇","640122200":"常信乡","640122400":"南梁台子管委会","640122401":"暖泉农场","640122402":"宁夏原种场","640122403":"京星农牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640122.json
// module id = 2816
// module chunks = 0